import type {
  DashboardBuilderState,
  DashboardHeaderChrome,
  DashboardHeaderWidget,
} from './types';

export const DEFAULT_DASHBOARD_HEADER_CHROME: DashboardHeaderChrome = {
  title: 'Dashboard builder',
  subtitle: 'Add ?edit=true to the URL to enter edit mode.',
  showLastUpdated: true,
};

export const DEFAULT_HEADER_WIDGETS: DashboardHeaderWidget[] = [
  { id: 'hw_time', type: 'header_date', label: 'Time window' },
];

/** Migrate legacy `header_selector` + `dimension` → `header_category` + `schemaField`. */
function migrateHeaderWidget(w: unknown): DashboardHeaderWidget {
  const t = w as { type?: string; id: string; label?: string; dimension?: string };
  if (t.type === 'header_selector') {
    return {
      id: t.id,
      type: 'header_category',
      label: t.label,
      schemaField: t.dimension ?? 'course',
    };
  }
  return w as DashboardHeaderWidget;
}

export function mergeDashboardHeaderDefaults(state: DashboardBuilderState): DashboardBuilderState {
  const rawWidgets =
    state.headerWidgets !== undefined ? state.headerWidgets : [...DEFAULT_HEADER_WIDGETS];
  return {
    ...state,
    header: { ...DEFAULT_DASHBOARD_HEADER_CHROME, ...state.header },
    headerWidgets: rawWidgets.map((item) => migrateHeaderWidget(item)),
  };
}
